"use client";
import { jsx, jsxs } from "react/jsx-runtime";
import styled from "styled-components";
const SVG = styled.svg`
  min-width: ${({ $size }) => $size};
  max-width: ${({ $size }) => $size};
  height: ${({ $size }) => $size};
`;
const ChevronRightLarge = ({ size = "1em", color = "currentColor", title, ...props }) => /* @__PURE__ */ jsxs(SVG, { ...props, $size: size, viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", role: title ? "img" : "presentation", children: [
  title ? /* @__PURE__ */ jsx("title", { children: title }) : null,
  " ",
  /* @__PURE__ */ jsx("path", { fill: color, d: "M16.678 11.9L8.37 3.592a.75.75 0 1 1 1.06-1.06l8.836 8.834a.782.782 0 0 1 .002.002.745.745 0 0 1 .004 1.057l-.006.006-8.837 8.837a.745.745 0 0 1-1.06 0 .75.75 0 0 1 .001-1.063l8.307-8.307z", children: " " })
] });
var ChevronRightLarge_default = ChevronRightLarge;
export {
  ChevronRightLarge_default as default
};
